import React from 'react'

const KnowledgeItem = ( {item} ) => {
    return (
        <li>
            <div className="name">{item}</div>
        </li>
    )
}

export default KnowledgeItem